/* unplugin-vue-components disabled */import { render } from "./xIcon.vue?vue&type=template&id=691f59b2"
import script from "./xIcon.vue?vue&type=script&lang=jsx"
export * from "./xIcon.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__